import script from "./CompanyBeatingHeartPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyBeatingHeartPanel.vue?vue&type=script&setup=true&lang=js"

import "./CompanyBeatingHeartPanel.vue?vue&type=style&index=0&id=7c51a956&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c51a956"]])

export default __exports__